/**
 * Cached easing-token reader for ESM components.
 *
 * Three early Phase 2/6 components (expandable-list, image-slider,
 * newsletter-subscribe) each hand-rolled the same `appGet('easing', 'ease')`
 * lookup with their own caching variant. Centralizing it both removes the
 * drift and gives Phase 10 templates a single import to reach for.
 *
 * Parameterized because callers read different keys: most want plain
 * `easing` from app-config, the slider wants `cssEasing.easeInOutCubic`.
 *
 * Source path: theme/js/core/easing.esm.js
 * Built name : ./easing.js
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [Easing]
 */

import { appGet } from './app-get.js';

const cache = new Map();

export function getEasing(path = 'easing', fallback = 'ease') {
  const cached = cache.get(path);
  if (cached) return cached;
  const v = appGet(path);
  if (v) {
    cache.set(path, v);
    return v;
  }
  return fallback;
}
